var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"e-backtop-btn js-e-backtop-btn",on:{"click":_vm.goTop}},[_c('i',{staticClass:"fas fa-arrow-up"}),_c('span',[_vm._v("TOP")])])])}
var staticRenderFns = []

export { render, staticRenderFns }